export const ALERT_TYPE_CLASS = {
  success: "alert-success",
  warning: "alert-warning",
  error: "alert-danger",
  info: "alert-info",
};
